import type { PiniaPluginContext } from 'pinia'
import { useStorage as useStorageVueUse } from '@vueuse/core'
import type { CheckoutCartModel } from '@/models/checkout-cart'
import { LocalStorage } from '~/models'

export const cartPiniaPlugin = async (context: PiniaPluginContext) => {
  if (process.client && context.store.$id === 'cart') {
    const DEFAULT_CART: CheckoutCartModel = {
      ePrescriptions: [],
      prescriptions: [],
      products: [],
      unavailableProducts: [],
      myLife: true,
    }

    const cartLocalStorage = useStorageVueUse<CheckoutCartModel>(LocalStorage.CartStorage, DEFAULT_CART)
    if (cartLocalStorage.value && cartLocalStorage.value.prescriptions && cartLocalStorage.value.products) {
      context.store.$state.cartData = cartLocalStorage.value
      context.store.$state.isStoreInitialized = true
    }

    context.store.$subscribe(() => {
      cartLocalStorage.value = context.store.$state.cartData
    })
  }
}
